module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2013_professional_winner-45c281f6a43211ee44d806a032c05095.jpg";